import React from 'react';
import { Navigate } from 'react-router-dom';

import Header from '@components/common/Header/Header';
import MapIconBtn from '@components/common/Header/components/BtnHeaderMap/BtnHeaderMap';
import Maps from '@components/common/Maps/Maps';

import useTranslation from '@hooks/useTranslation';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import SensorsEquipment from './components/SensorsEquipment/SensorsEquipment';
import style from './style.module.scss';

const SensorsTemperature = () => {
  const { t } = useTranslation();

  const { data: profileData } = useUserProfileQuery();

  if (profileData.customer.customer_id !== 502) {
    return <Navigate to="/" replace={true} />;
  }

  return (
    <>
      <Header
        title={t('Heat Map')}
        showLogo={true}
        showFacilitySelect={true}
        headerLeftComponent={<MapIconBtn />}
      />
      <Maps />
      <main className={style.sensorOverviewBlock}>
        <SensorsEquipment />
      </main>
    </>
  );
};

export default SensorsTemperature;
